import axios from "axios";
import { NotaRodape } from "models/nota_rodape_type";
import { UsuarioModel } from "models/user_model";
import { useEffect, useRef, useState } from "react";

const useFootNotes = () => {


const [accountTypeList, setAccountTypeList] = useState<NotaRodape[]>([]);
const [usuario, setUsuario] = useState<UsuarioModel>();
const [loading, setLoading] = useState(false);
const [show, setShow] = useState(false);
const [error, setError] = useState(false);
const [showDelete, setShowDelete] = useState(false);
const [accountSelected, setAccountSelected] = useState<NotaRodape>(null);
const nomeRef = useRef(null);
const descricaoRef  = useRef(null);
const cancelRef = useRef();
const add = () => {
  showModal(true);
};

const edit = (item: NotaRodape) => {
  showModal(true);
  setAccountSelected(item);
  nomeRef.current = item.nome;
  descricaoRef.current = item.descricao;
};

const showModal = (show: boolean) => {
  setShow(show);
  setError(false);
  if (!show) {
    nomeRef.current = null;
    setAccountSelected(null);
  }
};

const save = async () => {
  if (nomeRef.current !== null) {
    setError(false);
    if (!accountSelected) {
      await addRegister();
    } else {
      await updateRegister();
    }
    await loadData();
  } else {
    setError(true);
  }
};

const loadData = async () => {
  const userData = JSON.parse(localStorage.getItem("user"));
  setUsuario(userData);
  const response = await axios.get(
    process.env.REACT_APP_API_URL + "/nota-rodape/list/" + userData?.idEmpresa
  );
  if (response.data) {
    setLoading((prev) => (prev = false));
    setAccountTypeList(response.data);
  }
};

const addRegister = async () => {
  const obj = {
    nome: nomeRef.current,
    idEmpresa: usuario.idEmpresa,
    ativo: true,
    descricao : descricaoRef.current
  };
  const response = await axios.post(process.env.REACT_APP_API_URL + "/nota-rodape/", obj);
  if (response.data === true) {
    setLoading((prev) => (prev = false));
    showModal(false);
    nomeRef.current = null;
    setAccountSelected(null);
  }
};

const updateRegister = async () => {
  const obj = {
    id: accountSelected.id,
    nome: nomeRef.current.value ??  nomeRef.current,
    idEmpresa: accountSelected.idEmpresa,
    descricao : descricaoRef.current.value ?? descricaoRef.current,
    ativo: true,
  };
  const response = await axios.patch(
    process.env.REACT_APP_API_URL + "/nota-rodape/" + accountSelected.id,
    obj
  );
  if (response.data === true) {
    setLoading((prev) => (prev = false));
    showModal(false);
    nomeRef.current = null;
    setAccountSelected(null);
  }
};

const showDeleteModal = (item: NotaRodape) => {
  setShowDelete(true);
  setAccountSelected(item);
};

const closeDelete = () => {
  setShowDelete(false);
};

const deletar = async () => {
  const response = await axios.delete(
    process.env.REACT_APP_API_URL + "/nota-rodape/" + accountSelected?.id
  );
  if (response.data === true) {
    setLoading((prev) => (prev = false));
    showModal(false);
    nomeRef.current = null;
    setAccountSelected(null);
    setShowDelete(false);
    await loadData();
  }
};

useEffect(() => {
  loadData();
}, []);

return {
  accountTypeList,
  add,
  edit,
  loading,
  show,
  showModal,
  nomeRef,
  accountSelected,
  error,
  save,
  deletar,
  showDeleteModal,
  showDelete,
  cancelRef,
  closeDelete,
  descricaoRef
};
}


export default useFootNotes;